<template>
	<nav v-if="data" class="navbar navbar-default navbar-custom">
		<div class="container-fluid bold-400">
			<div class="navbar-header navbar-header-custom">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link :to="goTo('')" class="navbar-brand navbar-brand-custom bold" :title="data.name">
					Cliente <template v-if="$platform.setting.customers.custom_reference">{{ data.reference }}</template><template v-else>{{ $platform.setting.number_symbol }}{{ data.id }}</template>
				</router-link>
			</div>
			<template v-if="data.info">
				<div class="collapse navbar-collapse navbar-collapse-custom" id="bs-example-navbar-collapse-1">
					<ul class="nav navbar-nav">
						<li>
							<router-link :to="goTo('billings')">
								<i class="fa fa-file-text-o fa-fw" aria-hidden="true"></i>
								{{ $t('interface.fiscal_data') | ucfirst }}
								<span v-if="data.info">
									<span class="label label-rouded label-info">{{ data.info.billings }}</span>
								</span>
							</router-link>
						</li>
						<template v-if="data.info.budgets">
							<template v-if="data.info.budgets > 0">
								<li>
									<router-link :to="goTo('budgets')">
										<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
										Presupuestos
										<span class="label label-rouded label-info">{{ data.info.budgets }}</span>
									</router-link>
								</li>
							</template>
						</template>
						<template v-if="data.info.orders">
							<template v-if="data.info.orders > 0">
								<li>
									<router-link :to="goTo('orders')">
										<i class="fa fa-file-text" aria-hidden="true"></i>
										Pedidos
										<span class="label label-rouded label-info">{{ data.info.orders }}</span>
									</router-link>
								</li>
							</template>
						</template>
						<template v-if="data.info.invoices">
							<template v-if="data.info.invoices > 0">
								<li>
									<router-link :to="goTo('invoices')">
										<i class="fa fa-file-text" aria-hidden="true"></i>
										Facturas
										<span class="label label-rouded label-info">{{ data.info.invoices }}</span>
									</router-link>
								</li>
							</template>
						</template>
						<template v-if="data.info.projects">
							<template v-if="data.info.projects > 0">
								<li>
									<router-link :to="goTo('projects')">
										<i class="fa fa-file-text" aria-hidden="true"></i>
										Proyectos
										<span class="label label-rouded label-info">{{ data.info.projects }}</span>
									</router-link>
								</li>
							</template>
						</template>
						<template v-if="data.info.agreements">
							<template v-if="data.info.agreements > 0">
								<li>
									<router-link :to="goTo('agreements')">
										<i class="fa fa-handshake-o" aria-hidden="true"></i>
										Contratos
										<span class="label label-rouded label-info">{{ data.info.agreements }}</span>
									</router-link>
								</li>
							</template>
						</template>
						<template v-if="data.info.requests">
							<template v-if="data.info.requests > 0">
								<li>
									<router-link :to="goTo('requests')">
										<i class="fa fa-info-circle" aria-hidden="true"></i>
										Solicitudes
										<span class="label label-rouded label-info">{{ data.info.requests }}</span>
									</router-link>
								</li>
							</template>
						</template>
					</ul>
					<ul class="nav navbar-nav navbar-right">
						<li>
							<router-link :to="goTo('accounts')" title="Cuentas">
								<span class="hidden-xs">
									<i class="fa fa-university" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa fa-university fa-fw fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									Cuentas
								</span>
							</router-link>
						</li>
						<li>
							<router-link :to="goTo('docs')" :title="$tc('interface.doc', 2) | ucfirst">
								<span class="hidden-xs">
									<i class="fa fa-folder-open-o" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa fa-folder-open-o fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									{{ $tc('interface.doc', 2) | ucfirst }}
								</span>
								<span v-if="data.info.media > 0" class="label label-rouded label-info">{{ data.info.media }}</span>
							</router-link>
						</li>
						<li v-if="canPirnt()" @click="doPrint()">
							<a href="javascript:void(0)" :title="$t('interface.print') | ucfirst">
								<span class="hidden-xs">
									<i class="fa fa-print" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									<i class="fa fa-print fa-fw" aria-hidden="true"></i>
								</span>
								<span class="visible-xs-inline">
									{{ $t('interface.print') | ucfirst }}
								</span>
							</a>
						</li>
					</ul>
				</div>
			</template>
		</div>

		<fab
			:type="type"
			:data="data"
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>
	</nav>
</template>

<script>
	import Fav from './Fab'
	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			'fab': Fav
		},
		data () {
			return {
			}
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			goTo(to) {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/customers/' + this.data.id + '/' + to
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/customers/' + this.data.id + '/' + to
					}
				} else {
					var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/customers/' + this.data.id + '/' + to
				}

				return to
			},
			doPrint() {
				$(".printableArea").printThis({
					canvas: true,
				})
				this.updatePrinted()
			},
			canPirnt() {
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.name) {
							if(this.$route.meta.name == 'show') {
								return true
							}
						}
					}
				}

				return false
			},
			updatePrinted() {
				if(this.data) {
					this.$http.get('admin/customers/' + this.$route.params.id + '/printed')
					.then(response => {
						this.reload()
					}).catch(response => {
						console.log(response)
					})
				}
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Navbar.vue